module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"all":"Alle Blogbeiträge","blog":"Wir haben Geschichten zu erzählen","headline":"Blog"},"en":{"all":"All blog posts","blog":"We have stories to tell","headline":"Blog"},"it":{"all":"","blog":"","headline":""},"lt":{"all":"Visi įrašai","blog":"Dalinamės istorijomis","headline":"Tinklaraštis"},"pl":{"all":"wszystkie posty na blogu","blog":"Nasze historie","headline":"Blog"}}')
  delete Component.options._Ctor
}
